import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { TextSetting } from '../../../../textsetting';
import { SignupService } from '../../service/index';
import {
  UserService,
  SeoService,
  ValidationService,
  NgxToasterService,
} from '../../../../_services/index';
import { ScriptService } from '../../../../_services/script.service';

@Component({
  selector: 'app-email-verify',
  templateUrl: './email_verify.component.html',
  styleUrls: ['./email_verify.component.css'],
  providers: [
    UserService,
    SeoService,
    SignupService,
    ScriptService,
    BsModalRef,
    BsModalService,
  ],
})
export class EmailVerifyComponent implements OnInit {
  /**This is used to prevent memory leaks **/
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  /**This is used to prevent memory leaks **/

  env = environment;
  TextSetting = TextSetting;
  isLoading: boolean = false;
  otpSubmit: boolean = false;
  otpForm: FormGroup;
  otpFormError: any = {};
  email: any = '';
  @ViewChild('verify_otp', { static: true }) verify_otp:
    | ElementRef<HTMLElement>
    | any;
  @Output() emailVerified = new EventEmitter<boolean>();

  // Declare Constructor
  constructor(
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    public userService: UserService,
    private route: ActivatedRoute,
    public router: Router,
    private toasterNotification: NgxToasterService,
    private signupService: SignupService,
    private scriptService: ScriptService,
    private modalService: BsModalService,
    public modalRef: BsModalRef
  ) {
    //initialization otp form
    this.otpForm = this.formBuilder.group({});
  }

  // Declare initialization
  ngOnInit(): void {
    /**This function is used to create otp form */
    this.createOtpForm();
    /**This function is used to create otp form */
  }

  /**this function is used to open email verification modal*/
  openEmailModal() {
    this.otpForm.reset();
    this.otpFormError = {};
    this.scriptService
      .cssload('popup')
      .then((data: any) => {})
      .catch((error: any) => console.log(error));
    this.modalRef = this.modalService.show(this.verify_otp, {
      id: 1,
      class: 'mymodal',
      ignoreBackdropClick: true,
      backdrop: true,
      animated: true,
    });
  }

  /**this is used to close email verification modal*/
  closeModal(modalId?: number) {
    this.modalService.hide(modalId);
  }
  /**this is used to close email verification modal*/

  /**this is used to submit otp form on key press*/
  public otpFormSubmit(event: any) {
    if (event.keyCode === 13) {
      this.submitOtp();
    }
  }
  /**this is used to submit otp from on key press*/

  /**this is used to create otp form*/
  public createOtpForm(): void {
    this.otpForm = this.formBuilder.group({
      otp: ['', Validators.required],
    });
  }
  /**this is used to create otp form*/

  /**this is used to send otp on client email */
  public sendOtp(email: any) {
    this.openEmailModal();
    let formData: any = {};
    this.email = email;
    formData['user_id'] = this.userService.getCurrentUser()._id;
    formData['email'] = this.email;
    this.signupService
      .resendEmailOtp(formData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response: any) => {
        if (response.status === this.env.SUCCESS_STATUS) {
          this.toasterNotification.showSuccess(response.message);
        } else {
          this.toasterNotification.showError(response.message);
        }
      });
  }
  /**this is used to send otp on client email */

  /**this function is used to submit otp form */
  public submitOtp() {
    this.otpSubmit = true;
    if (this.otpForm.valid) {
      let formData = { ...this.otpForm.value };
      formData['user_id'] = this.userService.getCurrentUser()._id;
      formData['page'] = 'email_verify';
      this.signupService
        .submitEmailOtp(formData)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response: any) => {
          if (response.status === this.env.SUCCESS_STATUS) {
            this.otpSubmit = false;
            this.toasterNotification.showSuccess(response.message);
            this.otpForm.reset();
            this.otpFormError = {};
            this.closeModal();
            this.emailVerified.emit(true);
          } else {
            this.emailVerified.emit(false);
            if (
              response.errors !== undefined &&
              response.errors !== '' &&
              response.errors !== null
            ) {
              this.otpFormError = response.errors;
            } else {
              this.toasterNotification.showError(response.message);
            }
            this.otpSubmit = false;
          }
        });
    } else {
      this.otpSubmit = false;
      ValidationService.validateAllFormFields(this.otpForm);
    }
  }
  /**this function is used to submit otp form */

  /**this finction is used to resend otp*/
  public resendOtp() {
    let formData: any = {};
    formData['user_id'] = this.userService.getCurrentUser()._id;
    formData['email'] = this.email;
    this.signupService
      .resendEmailOtp(formData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response: any) => {
        if (response.status === this.env.SUCCESS_STATUS) {
          this.toasterNotification.showSuccess(response.message);
        } else {
          this.toasterNotification.showError(response.message);
        }
      });
  }
  /**this finction is used to resend otp*/

  /**This function are used for destroy the data**/
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
  }
  /**This function are used for destroy the data**/
}
